// Framework
import { Component, OnInit } from '@angular/core'
import { ConfigService } from '@consumer/app/services/config.service'

@Component({
  templateUrl: './start.component.html',
  styleUrls: ['./start.component.scss'],
})
export class HomeStartComponent implements OnInit {
  themeCurrent: any

  constructor(private configService: ConfigService) {
    this.themeCurrent = configService.config.theme
  }

  ngOnInit(): void {}
}
